<template>
	<div class="contents-body" :class="classes">
		<transition appear name="fade" mode="out-in" @before-enter="whenLoading" @after-enter="afterLoading">
			<keep-alive :exclude="['InGameOrder', 'in-game-order']">
				<router-view :key="$router.path" />
			</keep-alive>
		</transition>

		<dialogs-wrapper transition-name="fade-modal"></dialogs-wrapper>
		<!-- Dev info -->
		<DevInfo
			service-name="Checkout"
			:route-name="$route.name"
			:environment="environment"
			:current-version="currentVersion"
			:channel="channel"
			:web-api="webApi"
			:cdn-host="cdnHost"
		/>
	</div>
</template>

<script>
import { DevInfo } from '@arena/toolkit';
import config from './config/environment-config';

export default {
	name: 'App',
	components: {
		DevInfo,
	},
	metaInfo() {
		return {
			title: this.$t('checkout.title-header'),
			meta: [
				{ name: 'description', content: this.$t('checkout.meta-desc') },
				{ name: 'keywords', content: this.$t('checkout.meta-keyword') },
				{ property: 'og:site_name', content: this.$t('checkout.title') },
				{ property: 'og:type', content: 'website' },
				{ property: 'og:url', content: 'http://www.nexon.com/' },
				{ property: 'og:title', content: this.$t('checkout.title') },
				{ property: 'og:description', content: this.$t('checkout.meta-desc') },
				{ property: 'og:image', content: 'https://web.nxfs.nexon.com/nexon-logo.png' },
				{ itemprop: 'name', content: this.$t('checkout.meta-title') },
				{ itemprop: 'description', content: this.$t('checkout.meta-desc') },
				{ itemprop: 'image', content: 'https://web.nxfs.nexon.com/nexon-logo.png' },
				{
					'http-equiv': 'Content-Security-Policy',
					content: `default-src *.nexon.com *.nexon.io *.nexon.net *.google-analytics.com 'self';
						connect-src *.nexon.com *.nexon.net *.nexon.io *.serving-sys.com *.google-analytics.com 'self';
						script-src *.nexon.com *.nexon.net *.recaptcha.net *.google-analytics.com *.googletagmanager.com *.google.com *.facebook.net *.gstatic.com *.iesnare.com *.googleadservices.com *.doubleclick.net *.serving-sys.com  https://gleam.io 'unsafe-eval' 'unsafe-inline' 'self';
						style-src *.nexon.com *.google.com *.googleapis.com 'unsafe-inline';
						img-src *.nexon.com *.google.com *.google-analytics.com https://www.googletagmanager.com *.gstatic.com *.doubleclick.net 'self' data:;
						font-src *.nexon.com *.google.com *.facebook.com 'self';
						frame-src *.nexon.com *.nexon.net *.nexon.io *.google.com *.facebook.com *.skrill.com *.paysafecard.com ${
							process.env.VUE_APP_ENV === 'local'
								? '*.nexon.com:8300 *.nexon.com:8200  *.nexon.com:8100'
								: ''
						}`,
				},
			],
		};
	},
	computed: {
		classes() {
			return [this.channel, this.region, this.language, this.userAgent, `product-${this.productId}`];
		},
		webApi() {
			return config[process.env.VUE_APP_ENV][environment.region].checkoutAPI;
		},
		cdnHost() {
			return process.env.VUE_APP_CDN_HOST;
		},
		currentVersion() {
			return process.env.VUE_APP_VERSION;
		},
		environment() {
			return process.env.VUE_APP_ENV;
		},
		region() {
			return environment.region;
		},
		language() {
			return this.$i18n.locale;
		},
		isMobile() {
			return this.$store.state.isMobile ? 'mobile' : '';
		},
		isLauncher() {
			return navigator.userAgent.indexOf('NexonLauncher') > 0;
		},
		isGame() {
			return this.$store.state.appType === 'game';
		},
		isSteam() {
			// user for the steam nx purchase (when user is coming from the /wallet/steam-add-balance page) for applying display none for the header and footer and specific background color and image
			return this.$store.state.appType === 'steam';
		},
		channel() {
			if (this.isGame) return 'game';
			if (this.isLauncher) return 'launcher';
			if (this.isMobile) return 'mobile';
			if (this.isSteam) return 'steam';
			return 'web';
		},
		userAgent() {
			if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
				return 'safari';
			}
			return '';
		},
		productId() {
			const prodId = this.$cookie.get('CommerceProdId');
			return prodId;
		},
	},
	mounted() {
		this.storeChannel();
		this.$store.commit('startLoadingOverlay', this.$t('checkout.loading-checkout'));
		window.version = `Current Version => ${process.env.VUE_APP_VERSION}`;
		dataLayer.push({
			channel: this.channel,
			region: this.region,
			language: this.language,
		});

		this.$a2s.setRegion(this.region);
		this.$a2s.setCountryCode(this.language);
		this.$a2s.setIsDirect(this.isGame);
	},
	methods: {
		whenLoading() {
			const mainSpinner = document.getElementById('main-spinner');
			if (!mainSpinner.classList.contains('hide')) {
				mainSpinner.className += ' hide';
			}
			this.$store.commit('startLoadingOverlay', this.$t('checkout.loading-checkout'));
			this.$eventBus.$emit('show-loading-overlay');
		},
		afterLoading() {
			this.$eventBus.$emit('hide-loading-overlay');
		},
		storeChannel() {
			this.$store.commit('setAppType', this.channel);
			document.body.className = this.channel;
		},
	},
};
</script>

<style lang="less">
@import '~@arena/toolkit/src/less/toolkit/toolkit.less';
@import './less/global';
@import './less/responsive';
</style>
